module.exports = __webpack_public_path__ + "static/pod-intro-img-2-963b21b31ca636b532524743b0d9a3b7.png";